
////Usuario 1
//import Navbar from "../components/Navbar";
import Login from '../pages/login';
import Menu1 from '../pages/publicopartidos';
import Menu2 from '../pages/crearpartidos';
import Solicitudes from '../pages/solicitudes';
import Jugadores from '../pages/jugadores';
import Perfil from '../pages/perfil';
import Principal from '../pages/principal';
import Preguntas from '../pages/preguntas';

import Azuldirecta from '../pages/azuldirecta/principal';
import Entrenamientos from '../pages/azuldirecta/entrenamientos'
import AzulJugadores from '../pages/azuldirecta/jugadores'
import AzulLigas from '../pages/azuldirecta/ligas'
import AzulTransmisiones from '../pages/azuldirecta/transmisiones'


const Rutas = [



		{ path: '/', element: <Azuldirecta /> },
	{ path: '/entrenamientos', element: <Entrenamientos /> },
{ path: '/jugadores', element: <AzulJugadores /> },
{ path: '/ligas', element: <AzulLigas /> },
{ path: '/transmisiones', element: <AzulTransmisiones /> },



	{ path: '/falta1', element: <Login /> },
		{ path: '/falta1/login', element: <Login /> },
		{ path: '/falta1/principal', element: <Principal /> },
	{ path: '/falta1/partidos', element: <Menu1 /> },
{ path: '/falta1/crearpartidos', element: <Menu2 /> },
	{ path: '/falta1/solicitudes', element: <Solicitudes /> },
	{ path: '/falta1/jugadores', element: <Jugadores /> },
		{ path: '/falta1/perfil', element: <Perfil /> },
	{ path: '/falta1/faq', element: <Preguntas /> },
    ];


    export default Rutas;